var React = require('react');

function UserIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m47.3 23.7c0-13.1-10.6-23.7-23.6-23.7-13.1 0-23.7 10.6-23.7 23.7 0 8.6 4.6 16.1 11.4 20.3 0-6.7 5.5-12.2 12.3-12.2 6.7 0 12.2 5.5 12.3 12.2 6.8-4.2 11.3-11.7 11.3-20.3z","className":"svg-background","fill":"#e5ebe3","key":0}),React.createElement("g",{"className":"svg-primary","fill":"#231f20","key":1},[React.createElement("circle",{"cx":"23.7","cy":"21.7","r":"7.5","key":0}),React.createElement("path",{"d":"m23.7 31.7c-6.7 0-12.2 5.5-12.3 12.2 3.6 2.2 7.8 3.4 12.3 3.4s8.7-1.2 12.3-3.4c-.1-6.7-5.6-12.2-12.3-12.2z","key":1})])]);
}

UserIcon.defaultProps = {"enableBackground":"new 0 0 47.3 47.3","viewBox":"0 0 47.3 47.3"};

module.exports = UserIcon;

UserIcon.default = UserIcon;
